import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initGSAPGallery = () => {

	const bioRoot = document.querySelector('.hoffman-bios');
	const bioEntries = document.querySelectorAll('.bio-wrap');

	if (!bioEntries.length) return;


	bioEntries.forEach((bioEntry) => {
		const randomY = gsap.utils.random(-400, 400, 1, true);
		gsap.fromTo(
			bioEntry,
			{ y: randomY },
			{
				y: 0,
				scrollTrigger: {
					trigger: bioRoot,
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
				}
			});
		});
	};
	export { initGSAPGallery };